import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';

export function useHomepageSectionMutation(sectionId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updates: Record<string, unknown>) =>
      api.put(`/admin/homepage/${sectionId}`, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepage'] });
    },
  });
}
